import { FC } from "react";

import AddUserContainer from "@app/containers/user";

const AddUserPage: FC = () => <AddUserContainer />;

export default AddUserPage;
